import React, { useContext, useEffect, useState } from "react";
import { Alert, Card, Nav, Tab } from "react-bootstrap";
import { ProfileContext } from "../Auth/ProfileProvider";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import { FellowshipPrograms } from "../Shared/Models/FellowshipPrograms";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { TrainingProgramTypes } from "../Shared/Models/TrainingProgram";
import NotificationManager from "../SystemNotifications/NotificationManager";


const TabKeys = {
    Active: 'active' as string,
    Alumni: 'alumni' as string,
    Transfer: 'transfer' as string,
    Reports: 'reports' as string,
    Requirements: 'requirements' as string
} as const;

export default function Dashboard() {
    const { user } = useContext(ProfileContext);
    const [isFellowshipProgram, setIsFellowshipProgram] = React.useState<boolean>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [showApplicationAlert, setShowApplicationAlert] = useState<boolean>(true);

    useEffect(() => {
        const program = user?.trainingPrograms?.find(x => x.trainingProgramId === user.selectedTrainingProgramId);
        const isProgramFellowshipProgram = FellowshipPrograms.includes(program?.trainingProgramTypeId);

        setIsFellowshipProgram(isProgramFellowshipProgram);
        if (isProgramFellowshipProgram) {
            navigate("/Reports");
        }
    }, [user, user?.trainingPrograms, user?.selectedTrainingProgramId])

    const getActiveKeyFromLocation = () => {
        const pathName = location.pathname?.toLowerCase()
        if (pathName.includes(`/${TabKeys.Alumni}`)) return TabKeys.Alumni;
        if (pathName.includes(`/${TabKeys.Transfer}`)) return TabKeys.Transfer;
        if (pathName.includes(`/${TabKeys.Reports}`)) return TabKeys.Reports;
        if (pathName.includes(`/${TabKeys.Requirements}`)) return TabKeys.Requirements;

        return TabKeys.Active;
    }
    
    const showRequirementsTab = () => {
        const program = user?.trainingPrograms?.find(x => x.trainingProgramId === user.selectedTrainingProgramId);
        if (program.trainingProgramTypeId == TrainingProgramTypes.Neurology || program.trainingProgramTypeId == TrainingProgramTypes.Psychiatry || program.trainingProgramTypeId == TrainingProgramTypes.Cap || program.trainingProgramTypeId == TrainingProgramTypes.ChN || program.trainingProgramTypeId == TrainingProgramTypes.ChildNeurologyAndNeurodevelopmentalDisabilities || program.trainingProgramTypeId == TrainingProgramTypes.TripleBoard || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndInternalMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndInternalMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryAndFamilyMedicine || program.trainingProgramTypeId == TrainingProgramTypes.PsychiatryNeurology || program.trainingProgramTypeId == TrainingProgramTypes.PostPediatricPortal) {
            return true;
        }
        return false;
    }

    if (!user) return <AbpnSpinner />

    return (<>
        <Card className="border-pc-secondary-grey">
            <Card.Body>
            {showApplicationAlert &&
                    <Alert variant={"secondary"} onClose={() => setShowApplicationAlert(false)} dismissible>
                        <b>
                            NOTICE: Beginning in November, the ABPN will transition to a new, more secure password authentication platform. <br />
                            When logging in after the update, all preCERT users will be prompted to follow simple on-screen 
                            instructions to update their password. Once complete, your account will be securely migrated and 
                            further action required.
                        </b><br /><br />
                        Welcome to the ABPN preCERT system –<br /><br />
                        <b><i>ABPN recently sent our annual newsletter to all program directors which included clarifications 
                            about the ABPN continuity of training policy and reconfirming psychiatry residency primary care 
                            requirements. <a href="https://abpn.org/wp-content/uploads/2025/10/Annual-Program-Newsletter.pdf">Read the message from ABPN President and CEO, Dr. Jeffrey Lyness</a></i></b>
                        <br /><br />
                        Please visit abpn.org for <a href="https://abpn.org/quick-links/">application periods and exam administration dates</a> and <a href="https://abpn.org/access-residency-info/residency-training-information/abpn-precert-credentialing-system-webinar-series/"> general information about the preCERT system</a>,including FAQs and a recorded webinar. 
                        The ABPN application periods and examinations take place at relatively the same time each year.  By using the preCERT system, programs agree to the following guidelines:
                        <ul>
                            <li>Final attestation of completion of all training requirements for residents is done only by the program director.</li>
                            <li>Graduate Performance reports (GPRs) are made available only to program directors. GPRs are not to be shared with anyone outside of the training program leadership group (i.e., program directors, Chairs, etc.) as they contain confidential resident information. 
                                GPRs should not be shared with trainees or training program faculty.</li>
                        </ul>
                        If you have any questions, please contact us at <a  href={"mailTo:questions@abpn.org?subject=ABPN Account Help"}>questions@abpn.org</a>.
                    </Alert>
                }
                <NotificationManager></NotificationManager>
                <Tab.Container activeKey={getActiveKeyFromLocation()}>
                    <Nav variant="tabs">
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Active} as={Link} to={`/`}>Active Roster</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Alumni} as={Link} to={`/Alumni`}>Alumni Roster</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link className={isFellowshipProgram ? 'd-none' : ''} eventKey={TabKeys.Transfer} as={Link} to={`/Transfer`}>Transfer</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey={TabKeys.Reports} as={Link} to={`/Reports`}>Reports</Nav.Link>
                        </Nav.Item>
                        {showRequirementsTab() && 
                            <Nav.Item>
                                <Nav.Link eventKey={TabKeys.Requirements} as={Link} to={`/Requirements`}>Requirements</Nav.Link>
                            </Nav.Item>
                        }
                    </Nav>
                </Tab.Container>
                <Tab.Content className="mt-2">
                    <Outlet/>
                </Tab.Content>
            </Card.Body>
        </Card >
       
        </>
    );
}
